import { MainNavigation, ProductSearchBar } from '@ds-mgnl/marketing';
import { MxtLogo } from './MxtLogo';
import { ctaLinks, topNavData } from './topNavData';

export function TopNav({ transparent }: { transparent?: boolean }) {
	return (
		<MainNavigation
			transparent={transparent ?? false}
			navData={topNavData}
			navLogo={MxtLogo}
			ctaLinks={ctaLinks}
			searchBar={
				<ProductSearchBar
					transparent={transparent ?? false}
					searchEngineConfig={{
						analyticsTrackingId: 'maxwell-thomas',
						commerceProxyBaseUrl:
							process.env.COVEO_COMMERCE_PROXY_BASE_URL ?? '',
						analyticsProxyBaseUrl:
							process.env.COVEO_ANALYTICS_PROXY_BASE_URL ?? '',
					}}
				/>
			}
		/>
	);
}
